import { render } from "./CounterProposalListItem.vue?vue&type=template&id=197f3930&scoped=true"
import script from "./CounterProposalListItem.vue?vue&type=script&lang=ts"
export * from "./CounterProposalListItem.vue?vue&type=script&lang=ts"

import "./CounterProposalListItem.vue?vue&type=style&index=0&id=197f3930&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-197f3930"

export default script